import React, { useEffect, useState } from 'react';
import AdminDashboard from 'layouts/AdminDashboard';
import { Box, Breadcrumbs } from '@mui/material';
import { getAnswer, saveAnswer, updateAnswer } from './AnswerService';
import { useNavigate, useParams } from 'react-router-dom';
import Container from 'components/Container';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { notify } from 'utils/notify';
import { extractErrorMessage } from 'utils/extractErrorMessage';

const AnswerDetail = (): JSX.Element => {
  const [answerContent, setAnswerContent] = useState('');
  const [status, setStatus] = useState('');
  const navigate = useNavigate();
  const { answerid } = useParams<{ answerid: string }>();
  // const [loading, setLoading] = useState(false);
  const { questionid } = useParams();
  const { subscriptionid } = useParams();

  function clearAnswerDetailsForm() {
    setAnswerContent('');
    setStatus('');
  }

  const cancelSaveOrUpdateAnswer = () => {
    clearAnswerDetailsForm();
    navigate(
      `/admin/dashboard/subscription/${subscriptionid}/question/${questionid}/`,
    );
  };

  function saveOrUpdateAnswer(e) {
    e.preventDefault();

    const answer = {
      answerContent,
      status,
    };

    if (answerid) {
      const answerIdAsNumber: number = parseInt(answerid);
      updateAnswer(answerIdAsNumber, answer)
        .then(() => {
          navigate(
            `/admin/dashboard/subscription/${subscriptionid}/question/${questionid}/`,
          );
        })
        .catch((error) => {
          console.error(error);
          notify(extractErrorMessage(error));
        });
    } else {
      saveAnswer(subscriptionid, questionid, answer)
        .then(() => {
          navigate(
            `/admin/dashboard/subscription/${subscriptionid}/question/${questionid}/`,
          );
        })
        .catch((error) => {
          console.error(error);
          notify(extractErrorMessage(error));
        });
    }
  }

  useEffect(() => {
    if (answerid) {
      const answerIdAsNumber: number = parseInt(answerid);
      console.log('answerid exists: ', answerid);
      getAnswer(subscriptionid, answerIdAsNumber)
        .then((response) => {
          console.log(response.data);
          setAnswerContent(response.data.answerContent);
          setStatus(response.data.status);
        })
        .catch((error) => {
          console.error(error);
          notify(extractErrorMessage(error));
        });
    }
  }, [answerid]);

  return (
    <Container>
      <AdminDashboard>
        <Box marginTop={2} marginBottom={4}>
          <Breadcrumbs aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/">
              System Content
            </Link>
            <Link
              underline="hover"
              color="inherit"
              href="/system/dashboard/sections"
            >
              Answers
            </Link>
            <Typography color="text.primary">Answer Detail</Typography>
          </Breadcrumbs>
        </Box>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          marginBottom={4}
        >
          <Typography variant="h4">Answer Detail</Typography>
        </Box>
        {/* {loading && <p>Loading...</p>} */}

        <Box>
          <form>
            <Grid container spacing={4}>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Answer Content
                </Typography>
                <TextField
                  variant="outlined"
                  name={'name'}
                  fullWidth
                  value={answerContent} // Use the 'sequence' state variable as the value
                  onChange={(event) => setAnswerContent(event.target.value)} // Update the 'sequence' state variable on change
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography
                  variant={'subtitle2'}
                  sx={{ marginBottom: 2 }}
                  fontWeight={700}
                >
                  Status
                </Typography>
                <TextField
                  variant="outlined"
                  name={'status'}
                  fullWidth
                  value={status}
                  onChange={(event) => setStatus(event.target.value)}
                />
              </Grid>
              <Grid item container xs={12}>
                <Box
                  display="flex"
                  flexDirection={{ xs: 'column', sm: 'row' }}
                  alignItems={{ xs: 'stretched', sm: 'center' }}
                  justifyContent={'space-between'}
                  width={1}
                  //margin={'0 auto'}
                  marginBottom={4}
                >
                  {/* <Box marginBottom={{ xs: 1, sm: 0 }}>
                    <Typography variant={'subtitle2'}>
                      You may also consider to update your{' '}
                      <Link color={'primary'} href={'#'} underline={'none'}>
                        billing information.
                      </Link>
                    </Typography>
                  </Box> */}
                  {/* <Button size={'large'} variant={'contained'} type={'submit'}>
                    Save
                  </Button> */}
                  <Button onClick={cancelSaveOrUpdateAnswer}>Cancel</Button>
                  <Button onClick={saveOrUpdateAnswer}>Save</Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        </Box>
      </AdminDashboard>
    </Container>
  );
};

export default AnswerDetail;
